/* Page to fetch one series of IndexShots data
 * Contains IndexShot component to which it passes the data 
   for each IndexShot
 * Initially sets data in the state indexShotsAll
 * Contains 3 functions to filter the 1st 90 indexShots in groups
   of 30 and one function to filter the rest
 * Contains component IndexShotCreate at the top and botton of the page
 * Contains component Info2 */
import React, { useEffect, useState } from "react"
import Form from "react-bootstrap/Form"
import { axiosInstance, axiosReq } from "../../api/axiosDefaults"
import NoResults from "../../assets/no-results.png"
import Asset from "../../components/Asset"
import appStyles from "../../App.module.css"
import TopBox from "../../components/TopBox"
import { useRedirect } from "../../hooks/Redirect"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import Button from "react-bootstrap/Button"
import Container from "react-bootstrap/Container"
import styles from "../../styles/Indexes.module.css"
import btnStyles from "../../styles/Button.module.css"
import { useParams, useHistory } from "react-router-dom"
import Info2 from "./Info2"
import IndexShotCreate from "./IndexShotCreate"
import IndexShot from "./IndexShot"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import IndexShot2 from "./IndexShot2"

const IndexShotsPage = () => {
  useRedirect()
  const currentUser = useCurrentUser()
  const host = useHostName()
  const [indexShots, setIndexShots] = useState({ results: [] })
  const [indexShotsAll, setIndexShotsAll] = useState({ results: [] })
  // eslint-disable-next-line
  const [series, setSeries] = useState({ results: [] })
  const [seriesName, setSeriesName] = useState("")
  // eslint-disable-next-line
  const [error, setError] = useState({})
  const { id } = useParams()
  const [hasLoaded, setHasLoaded] = useState(false)
  const [query, setQuery] = useState("")
  const message = "No Results"
  const history = useHistory()
  const [showInfo, setShowInfo] = useState(false)
  const [hasOrder, setHasOrder] = useState(false)
  const [show, setShow] = useState(false)
  const [show2, setShow2] = useState(false)
  const [shotOnly, setShotOnly] = useState(false)

  useEffect(() => {
    /* Function to fetch a Series And it's set of IndexShots data
             Set states indexShots and indexShotsAll to the data returned */
    const fetchseries = async () => {
      try {
        if (host === CLIENT_PROGRAM_HOSTNAME) {
          const [{ data: seriesGet }, { data: shotsGet }] = await Promise.all([
            axiosReq.get(`/series/${id}`),
            axiosReq.get(`/indexshots/?series_id=${id}&search=${query}`),
          ])
          setSeries({ results: [seriesGet] })
          setIndexShots(shotsGet)
          setIndexShotsAll(shotsGet)
          setSeriesName(seriesGet.name)
          setHasLoaded(true)
          setHasOrder(false)
        } else {
          const [{ data: seriesGet }, { data: shotsGet }] = await Promise.all([
            axiosInstance.get(
              `${localStorage.getItem("projectSlug")}/series/${id}/`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
            axiosInstance.get(
              `${localStorage.getItem(
                "projectSlug"
              )}/indexshots/?series_id=${id}${query ? `&search=${query}/` : ""
              }`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              }
            ),
          ])
          setSeries({ results: [seriesGet] })
          setIndexShots(shotsGet)
          setIndexShotsAll(shotsGet)
          setSeriesName(seriesGet.name)
          setHasLoaded(true)
          setHasOrder(false)
        }
      } catch (err) {
        setError(err)
        console.log(err)
      }
    }
    setHasLoaded(false)

    const timer = setTimeout(() => {
      fetchseries()
    }, 500)

    return () => {
      clearTimeout(timer)
    }

    // eslint-disable-next-line
  }, [query, hasOrder])

  const handleClickAll = () => {
    setIndexShots(indexShotsAll)
  }

  const handleClick1 = () => {
    const thirty = indexShotsAll.results.filter(
      (shot) => shot.number > 0 && shot.number < 31
    )
    setIndexShots({ results: thirty })
  }

  const handleClick2 = () => {
    const sixty = indexShotsAll.results.filter(
      (shot) => shot.number > 30 && shot.number < 61
    )
    setIndexShots({ results: sixty })
  }

  const handleClick3 = () => {
    const ninety = indexShotsAll.results.filter(
      (shot) => shot.number > 60 && shot.number < 91
    )
    setIndexShots({ results: ninety })
  }

  const handleClick4 = () => {
    const end = indexShotsAll.results.filter((shot) => shot.number > 90)
    setIndexShots({ results: end })
  }

  const handleTopAdd = () => {
        setShow(show => !show)
        setShow2(false)
        console.log("top ")
        };

        const handleBotAdd = () => {
        setShow2(show => !show)
        setShow(false)
        console.log("bottom ")
        };

  return (
    <div>
      <TopBox title={seriesName} />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} mt-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Button
        className={`float-right py-0 mt-1 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowInfo((showInfo) => !showInfo)}
      >
        INFO
      </Button>
      {!showInfo ? "" : <Info2 />}
      <h3 className="text-center">{seriesName}</h3>
      <hr className={`mt-0 mb-0 py-1 ${styles.BreakTitle}`}/>
      {/* Add Index Shot - display */}
          <Row className="mb-3 mt-2">
            <Col className="text-center" xs={6}>
            {currentUser?.groups[0]?.name !== "Crew" &&
              <Button
                onClick={() => handleTopAdd()}
                className={`${btnStyles.Button} ${btnStyles.Shed} px-5`}
              >
                ADD INDEXSHOT
              </Button>
            }
            </Col>
            <Col className="text-center" xs={6} >
            <Button
              className={`px-5 py-0 ${btnStyles.Shed} ${btnStyles.Button}`}
              onClick={() => setShotOnly((shotOnly) => !shotOnly)}
            >
              SHOT DISPLAY
            </Button>
            </Col>
          </Row>
          {!show ? ("") : (<IndexShotCreate 
                           seriesName={seriesName}
                           setShow={setShow} 
                           setHasOrder={setHasOrder} /> ) } 
      {/* filter */}
      <Row className="mt-3">
        <Col className="text-center" xs={{span: 10, offset: 1}}>
          <Button
            className={`py-0 ${btnStyles.ButtonS} ${btnStyles.GreyDark} px-5`}
            onClick={() => handleClickAll()}
          >
            All Shots
          </Button>
        </Col>
      </Row>
      <Row className="mt-3 mt-md-0">
        <Col className="text-center" xs={6} md={3}>
          <Button
            className={`py-0 ${btnStyles.ButtonS} ${btnStyles.GreyDark}`}
            onClick={() => handleClick1()}
          >
            Shots 1 - 30
          </Button>
        </Col>
        <Col className="text-center" xs={6} md={3}>
          <Button
            className={`py-0 ${btnStyles.ButtonS} ${btnStyles.GreyDark}`}
            onClick={() => handleClick2()}
          >
            Shots 31 - 60
          </Button>
        </Col>
        <Col className="text-center" xs={6} md={3}>
          <Button
            className={`py-0 mt-2 mt-md-0 ${btnStyles.ButtonS} ${btnStyles.GreyDark}`}
            onClick={handleClick3}
          >
            Shots 61 -90
          </Button>
        </Col>
        <Col className="text-center" xs={6} md={3}>
          <Button
            className={`py-0 mt-2 mt-md-0  ${btnStyles.ButtonS} ${btnStyles.GreyDark}`}
            onClick={handleClick4}
          >
            Shots 91 - end
          </Button>
        </Col>
      </Row>
      {/* search  */}
      <Row>
        <Col className="my-3" xs={{ span: 6, offset: 3 }}>
          <Form
            className={styles.SearchBar}
            onSubmit={(event) => event.preventDefault()}
          >
            <Form.Control
              value={query}
              onChange={(event) => setQuery(event.target.value)}
              type="text"
              className={`${styles.InputBarShot}`}
              placeholder="Search by Shot Number"
            />
          </Form>
        </Col>
      </Row>
      {/* series */}
      <Row className="py-2 ">
        {hasLoaded ? (
          <>
            {indexShots.results.length ? (
              indexShots.results.map((shot) => (
                <Col
                  key={shot.id}
                  xs={12}
                  md={6}
                  lg={4}
                  className="py-2"
                >
                  {!shotOnly ? (
                    <IndexShot
                    ser_id={id}
                    setHasOrder={setHasOrder}
                    {...shot}
                    shot={shot}
                    setIndexShots={setIndexShots}
                  />
                  ) : (
                    <IndexShot2
                    ser_id={id}
                    setHasOrder={setHasOrder}
                    {...shot}
                    shot={shot}
                    setIndexShots={setIndexShots}
                  />
                  ) }
                </Col>
              ))
            ) : (
              <Container className={appStyles.Content}>
                <Asset src={NoResults} message={message} />
              </Container>
            )}
          </>
        ) : (
          <Container className={appStyles.Content}>
            <Asset spinner />
          </Container>
        )}
      </Row>
      {/* add */}
      {
        currentUser?.groups[0]?.name !== "Crew" &&
        <>
          <Row className="my-3">
            <Col className="text-center">
            {indexShots.results.length ? (
            <Button
                // onClick={() => setShow2((show2) => !show2)}
                onClick={() => handleBotAdd()}
                className={`${btnStyles.Button} ${btnStyles.Bright} px-5`}
              >
                Add Shot
              </Button>
            ) : ("")}
            </Col>
          </Row>
          {!show2 ? (
            ""
          ) : (
            <IndexShotCreate
              seriesName={seriesName}
              setShow={setShow2}
              setHasOrder={setHasOrder}
            />
          )}
        </>
      }

    </div>
  )
}

export default IndexShotsPage
